import { useEffect, useMemo } from 'react'
import { useGetAllAssistant } from '../services/usePredict'
import { useMainContext } from '../../../modules/Dashboard'

/**
 * useFastScans
 *
 * Returns FastScan assistants filtered by market.
 *
 * @param {Object} params
 * @param {'forex' | 'crypto'} [params.market]
 *  Optional market filter.
 *  - If provided, only FastScans for the given market will be returned.
 *  - If set to all or undefined, FastScans for ALL markets will be returned.
 *
 * @returns {Object}
 * @returns {boolean} returns.loading - Indicates loading or fetching state.
 * @returns {Array} returns.fastScans - List of FastScan assistants based on market filter.
 */


const useFastScans = ({ market }) => {
    const { isLoading, isFetching, data: assistants, refetch } = useGetAllAssistant()
    const { main: { lang } } = useMainContext()

    const fastScans = useMemo(() => {
        if (!assistants) return []
        return assistants.filter(a => a.value.startsWith('fs-'))
    }, [assistants])

    const marketFastScans = useMemo(() => {
        if (!market || market === "all") {
            return [...fastScans]
        }

        return fastScans.filter(a => a.tickerCase === market)
    }, [fastScans, market])



    useEffect(() => {
        refetch()
    }, [lang])

    return {
        loading: isLoading || isFetching,
        fastScans: marketFastScans
    }
}

export default useFastScans
